import { useState } from "react";

interface FileData {
  filename: string;
  content: string;
  size: number;
  type: string;
}

/**
 * Custom hook for managing file uploads
 */
export const useFileUpload = () => {
  const [selectedFiles, setSelectedFiles] = useState<FileData[]>([]);

  const handleFilesSelected = (files: FileData[]) => {
    setSelectedFiles(files);
  };

  const removeFile = (index: number) => {
    setSelectedFiles((files) => files.filter((_, i) => i !== index));
  };

  const clearFiles = () => {
    setSelectedFiles([]);
  };

  return {
    selectedFiles,
    handleFilesSelected,
    removeFile,
    clearFiles,
  };
};
